import React from 'react';
import { HStack, VStack, ScrollView } from '@gluestack-ui/themed';

import FormField from '../../../../common/components/forms/FormField';
import ObjectIdField from '../../../common/ObjectIdField';
import SettingsGroupCard from '../../../../common/components/forms/SettingsGroupCard';

const CohortDetailsForm = () => (
  <ScrollView flex={1} bg="$backgroundLight0">
    <VStack space="xl" py="$6">
      <SettingsGroupCard title="Cohort Information">
        <VStack space="lg">
          <FormField
            name="title"
            label="Title"
            type="text"
            fieldWidth="100%"
            rules={{ required: 'Cohort must have a title' }}
          />

          <HStack space="lg">
            <FormField
              name="state"
              label="State"
              type="select"
              fieldWidth="180px"
              choices={[
                { label: 'Active', value: 'active' },
                { label: 'Stale', value: 'stale' },
                { label: 'Retired', value: 'retired' },
              ]}
              defaultValue="active"
              rules={{ required: 'Cohort must have a state' }}
            />
            <FormField name="isDeprecated" label="Deprecated" type="switch" defaultValue={false} />
          </HStack>
        </VStack>
      </SettingsGroupCard>

      <ObjectIdField />
    </VStack>
  </ScrollView>
);

export default CohortDetailsForm;
